import { render, staticRenderFns } from "./StartProjectModal.vue?vue&type=template&id=d7fbda96&"
import script from "./StartProjectModal.vue?vue&type=script&lang=ts&"
export * from "./StartProjectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports